import dynamic from "next/dynamic";
import React, { useContext, useEffect, useRef, useState } from "react";
import { AvailabilityCalendar } from "../../Components/Property/AvailabilityCalendar/web";
import { BigDataSingleProp } from "../../Components/BigData/SingleProp/web";
import { BreadCrumbs } from "shared-components/Components/SEO/BreadCrumbs/web";
import { SeoText } from "shared-components/Components/SEO/SeoText/web";
import { Card, Col, Grid, Row, Typography } from "antd";
import { ConfigStateContext } from "../../Contexts/Configurations/context";
import { Description } from "../../Components/Property/Description/web";
import { Facilities } from "../../Components/Property/Facilities/web";
import { Financing } from "../../Components/Financing/web";
import { Footer } from "../Footer/web";
import { Guarantee } from "shared-components/Components/Property/Guarantee/web";
import { InformationRequest } from "../../Components/Property/InformationRequest/web";
import { hasRooms, isTemporal, ocultarBigDataFicha_aPedidoHardcodeado } from "../../Utils/Functions";
import { LoadOnScreen, OnScreen } from "../../Components/OnView/web";
import { Navigation } from "./Navigation/web";
import { OfficeHours } from "../../Components/OfficeHours/web";
import { PicHomeFooter } from "../Footer/PicHomeFooter/web";
import { PriceTag } from "../../Components/Property/PriceTag/web";
import { ProjectInfo } from "../../Components/Project/Info/web";
import { PropertyAffixBottom } from "./PropertyAffixBottom/web";
import { PropertyAffixHeader } from "./PropertyAffixHeader/web";
import { PropertyCover } from "./PropertyCover/web";
import { PropertyLocalInformationMap } from "./PropertyLocalInformation/web";
import { Subsidiaries } from "../../Components/Property/Subsidiaries/web";
import { TechnicalSheet } from "../../Components/Property/TechnicalSheet/web";
import { TemporaryRental } from "../../Components/Property/TemporaryRental/web";
import { Title } from "../../Components/Property/Title/web";
import { TypologyTag } from "../../Components/Property/TypologyTag/web";
import { Units } from "../../Components/Project/Units/web";
import { useGoogleTagManager } from "../../GlobalHooks/web/GoogleTagManager.hook";
import { useMarkSeen } from "../../Components/Property/SeenStatus/SeenStatus.hook";
import { useRouter } from "next/router";
import { useTheme } from "../../Styles/ThemeHook";
import { WorkProgress } from "../../Components/Project/WorkProgress/web";
import "./styles.less";
import { FichaStructData } from "shared-components/Components/Property/FichaStructData";
import Head from "next/head";
import dayjs from "dayjs";
import Header from "RefactorSearchPage/Header/web";
import { CloseButton } from "shared-components/Components/CustomIcons/CloseButton/web";
import { useCreateSearchAlert } from "shared-components/Components/SearchAlert/CreateSearchAlert/hook";
import { EventBanner } from "src/Components/Eventos/EventBanner/web";
import Show from "src/Components/Show/web";
import usePropertyData from "src/hooks/propertyData/usePropertyData";
import { getSimilars } from "src/services/search";
import {
	firstLetterToUppercase,
	getLocationLabel,
	getProjectCommertialUnitsOrdered,
	getProjectRangePrices,
} from "src/utils/Functions";
import { ListingType } from "shared-components";
import ErrorPage from "pages/errorPage";
import { OpenEyeIcon } from "shared-components/Components/CustomIcons/OpenEyeIcon/web";
import { CloseEyeIcon } from "shared-components/Components/CustomIcons/CloseEyeIcon/web";
import { ModalConsulta } from "shared-components/Components/Property/InformationRequest/LeadButtons/FormButton/ModalConsulta";
import { useContactModal } from "shared-components/Contexts/ContactModal/context";
import { useIsAuthModalShowing } from "shared-components/GlobalHooks/useIsAuthModalShowing";
import { OwnerInfo } from "shared-components/Components/Property/OwnerInfo/web";
import { FincaClicLogo } from "shared-components/Components/FincaClicLogo/web";
import { FireIcon } from "shared-components/Components/CustomIcons/FireIcon/web";
import { PropertyInactive } from "./PropertyInactive/web";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";
import { trackNpsFichaView } from "shared-components/Components/NpsSurveyCard/npsSurvey.service";

const { Text } = Typography;
const { useBreakpoint } = Grid;

//@ts-ignore
const PropertySimilars = dynamic(
	(): any => import("./PropertySimilars/web").then(mod => mod.PropertySimilars),
	{ ssr: false }
);

//@ts-ignore
const PropertyModal = dynamic(
	(): any => import("./PropertyModal/web").then(mod => mod.PropertyModal),
	{ ssr: false }
);
//@ts-ignore
const Modal = dynamic((): any => import("antd").then(mod => mod.Modal), { ssr: false });
//@ts-ignore
const PropertySimilarsCards = dynamic(
	(): any =>
		import("./PropertySimilars/PropertySimilarsCards/web").then(
			mod => mod.PropertySimilarsCards
		),
	{ ssr: false }
);

export function PropertyDetails({ id, mode = "auto", data }) {
	if (!data) {
		return <ErrorPage statusCode={404} apolloClient={undefined} apolloState={undefined} />;
	}
	const { country_code, site_name, country_name } = useContext(ConfigStateContext);
	const { translations } = useContext(ConfigStateContext);
	const { listing, loading, setSimilars, setIsLoadingSimilars } = usePropertyData();
	const { searchAlert } = useCreateSearchAlert();
	const { theme } = useTheme();
	const { isVisible, modalData, closeContactModal } = useContactModal();
	const { isAuthModalShowing } = useIsAuthModalShowing();
	const { markSeen } = useMarkSeen();
	const router = useRouter();
	const screen = useBreakpoint();
	const windowSize = useWindowSize();
	const GTM = useGoogleTagManager();
	const financingRef = useRef(null);
	const [top, setTop] = useState(0);
	const [isModalOpen, setModalOpen] = useState(false);
	const [modalTabOpen, setModalTabOpen] = useState("photos");
	const [scrollDown, setScrollDown] = useState(false);
	const [showAffixInNotActive, setShowAffixInNotActive] = useState(false);
	const [showAffix, setShowAffix] = useState(false);
	const [showAffixBottom, setShowAffixBottom] = useState(true);
	const [queryRouter, setRouterQuery] = useState<string>("");
	const [minAndMaxUnits, setMinAndMaxUnits] = useState<any>({});

	const operationTypeId = listing.operation_type?.id;
	const propertyTypeId = listing.property_type?.id;

	/* en proyectos, TypologyTag recibe los valores de todas las unidades ordenados
	ascendente para que pueda mostrar el menor; se descartan negativos (data inválida) */
	const projectUnits =
		listing.isProject && Array.isArray(listing.commercial_units)
			? listing.commercial_units
			: [];
	const getUnitsSortedValues = (units: any[], getValue: (unit: any) => any) => {
		const values = units
			.map(getValue)
			.filter(value => value != null && value !== "" && Number(value) >= 0)
			.sort((a, b) => Number(a) - Number(b));

		return values.length ? values : undefined;
	};
	
	const bedroomsUnits = projectUnits.filter(
		unit =>
			Number(unit.property_type?.id) !== 3 &&
			!hasRooms(unit.property_type?.id, country_code)
	);
	const roomsUnits = projectUnits.filter(unit =>
		hasRooms(unit.property_type?.id, country_code)
	);
	const projectBedrooms = getUnitsSortedValues(bedroomsUnits, unit => unit.bedrooms);
	const projectRooms = getUnitsSortedValues(roomsUnits, unit => unit.rooms);
	const projectBathrooms = getUnitsSortedValues(projectUnits, unit => unit.bathrooms);
	const SCROLL_LIMIT_IN_LISTING_NOT_ACTIVE = -800;
	const shouldShowMobileAffix =
		windowSize.viewportWidth !== null && !windowSize.lg;

	const [showAllNeighbourhoods, setShowAllNeighbourhoods] = useState(false);
	const neighbourhoods = listing?.locations?.neighbourhood;
	const neighbourhoodNames = neighbourhoods && neighbourhoods?.map?.(n => n.name);
	const displayedNeighbourhoods = showAllNeighbourhoods
		? neighbourhoodNames
		: neighbourhoodNames?.slice(0, 3);

	const handleScroll = () => {
		const HEADER = 84;
		const HEADER_AFFIX = 164;

		const scroll = window.pageYOffset;
		const form = document.getElementById("myForm");
		const alturaForm = form?.offsetTop;

		if (scroll > alturaForm - HEADER_AFFIX) {
			form.classList.add("sticky");
			showAffix ? setTop(HEADER_AFFIX) : setTop(HEADER);
		} else {
			form.classList.remove("sticky");
			setTop(0);
		}
	};

	const handleClickShowNotification = async ({
		type = "success",
		message = "",
		description = "",
	}) => {
		const { showNotification } = await import(
			"shared-components/Components/CustomNotification/web"
		);
		showNotification(type, message, description);
	};

	const showLogo = listing => {
		if (listing.isProject && listing.logo && listing.logo !== "") {
			return true;
		} else return false;
	};

	const isProjectValue = () => {
		if (data.isProject && data.isProjectUnit) return true;
		else if (data.isProject && !data.isProjectUnit) return true;
		else if (!data.isProject && !data.isProjectUnit) return false;
		return false;
	};

	useEffect(() => {
		let type: ListingType = mode === "property" ? "PROPERTY" : "PROJECT";
		markSeen(id, type);

		if (!data.isProject) {
			const isProjectv = isProjectValue();

			getSimilars(data.id, isProjectv, 6).then(fetchResult => {
				setSimilars(fetchResult);
				setIsLoadingSimilars(false);
			});
		} else {
			setIsLoadingSimilars(false);
		}
	}, []);

	useEffect(() => {
		// Next.js reutiliza esta instancia al navegar entre fichas dentro del mismo route
		// (propSingle.tsx), por lo que este efecto necesita depender de `id` explícitamente
		// en vez de correr una sola vez por montaje.
		trackNpsFichaView();
	}, [id]);

	useEffect(() => {
		if (router.query?.call === "1") setRouterQuery("call");
		if (router.query?.wpp === "1") setRouterQuery("wpp");
		if (router.query?.bell === "1") setRouterQuery("bell");
		if (router.query?.makeorder === "1") setRouterQuery("makeorder");
		if (router.query?.mailConsulta === "1") setRouterQuery("mailConsulta");
	}, [router.query]);

	useEffect(() => {
		const Ybug = window["Ybug"];
		if (isModalOpen && Ybug && !screen.lg) Ybug?.hide("launcher");

		return () => Ybug?.show("launcher");
	}, [isModalOpen]);

	useEffect(() => {
		if (listing.id) {
			GTM.Event({
				name: "offerdetail",
				data: {
					listing_id: listing.id,
					listing_pagetype: "offerdetail",
					listing_totalvalue: listing.price?.amount,
				},
			});

			if (
				!listing.isProject &&
				listing &&
				"operation_type" in listing &&
				listing.operation_type &&
				"property_type" in listing &&
				listing.property_type &&
				"estate_id" in listing &&
				listing.estate_id
			) {
				localStorage.setItem(
					"propertyIdealFilters",
					JSON.stringify({
						operation_type_id: Number(listing.operation_type.id),
						property_type_id: [Number(listing.property_type.id)],
						estate_id: Number(listing.estate_id),
						maxPrice: listing.price?.amount + listing.price?.amount * 0.2,
						bedrooms: [listing.bedrooms],
						currencyID: Number(listing.price?.currency.id),
					})
				);
			}

			if (Array.isArray(listing.commercial_units) && !!listing.commercial_units.length) {
				let commercialUnits = getProjectCommertialUnitsOrdered({ listing });
				const prices = getProjectRangePrices({ listing });
				const minUnit = { ...commercialUnits?.[0], price: prices.minPrice };
				const maxUnit = {
					...commercialUnits?.[commercialUnits?.length - 1],
					price: prices.maxPrice,
				};

				setMinAndMaxUnits({ minUnit, maxUnit });
			}
		}
	}, [listing]);

	useEffect(() => {
		let scrollPosition = 0;
		const onScroll = () => {
			if (document.body.getBoundingClientRect().top > scrollPosition) {
				setScrollDown(false);
			} else {
				setScrollDown(true);
			}

			scrollPosition = document.body.getBoundingClientRect().top;

			if (!listing.active) {
				if (scrollPosition > SCROLL_LIMIT_IN_LISTING_NOT_ACTIVE) {
					setShowAffixInNotActive(false);
				}
			}
		};

		window.addEventListener("scroll", onScroll, { passive: true });

		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	useEffect(() => {
		if (queryRouter && queryRouter === "makeorder") {
			const idealFilters = JSON.parse(localStorage.getItem("propertyIdealFilters"));
			if (idealFilters) {
				searchAlert.customForm(1, `Quiero que ${site_name} busque por mí`, idealFilters);
				handleClickShowNotification({
					message: "Tu pedido fue enviado!",
					type: "success",
				});
			}
		}
	}, [queryRouter]);

	useEffect(() => {
		if (!listing.active) {
			if (showAffix) {
				if (
					document.body.getBoundingClientRect().top > SCROLL_LIMIT_IN_LISTING_NOT_ACTIVE
				) {
					setShowAffixInNotActive(false);
				} else {
					if (scrollDown) {
						setShowAffixInNotActive(true);
					} else {
						setShowAffixInNotActive(false);
					}
				}
			} else {
				setShowAffixInNotActive(false);
			}
		} else {
			setShowAffixInNotActive(showAffix);
		}
	}, [showAffix]);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => window.removeEventListener("scroll", handleScroll);
	});

	let isOld = listing?.updated_at
		? dayjs(listing.updated_at).isBefore(dayjs().subtract(1, "year"))
		: false;

	if (loading) return null;


	// if (!listing.active) return <PropertyInactive listing={listing} mode={mode} />;

	return (
		<>
			{isOld && !listing.active && (
				<Head>
					<meta name="robots" content="noindex, nofollow" />
				</Head>
			)}

			<div className="property-detail-container">
				<FichaStructData prop={listing} mode={mode} />

				{listing.isExternal && (
					<Head>
						<meta name="robots" content="noindex, nofollow" />
					</Head>
				)}

				<Header showArrow={true} />
				<div className="property-detail">
					{listing.project &&
						!!listing.project.length &&
						listing.project[0].event &&
						listing.project[0].event.show && (
							<EventBanner
								link={listing.project[0].event.link}
								logo={listing.project[0].event.logo}
								date={listing.project[0].event.startDate}
							/>
						)}
					{/* Show Affix && Property Affix Header */}
					{showAffix && showAffixInNotActive && screen.lg && (
						<PropertyAffixHeader id={listing.id} listing={listing} mode={mode} />
					)}
					{/* Property Modal */}
					{isModalOpen && (
						<Modal
							className="pd-property-modal"
							visible={isModalOpen}
							centered
							footer={null}
							closeIcon={<CloseButton />}
							onCancel={() => setModalOpen(false)}>
							<PropertyModal
								activeTab={modalTabOpen}
								onChangeTab={tab => setModalTabOpen(tab)}
								onClose={() => setModalOpen(false)}
								propId={id}
								mode={mode}
								listing={listing}
								isDisabledProperty={!listing.active}
							/>
						</Modal>
					)}

					{/* Main */}
					<div className="pd-main container pd-container pd-main-row">
						{/* Navigation */}
						{screen.lg && (
							<div className="container padding-small pd-navigation-col">
								<Navigation type="default" />
							</div>
						)}

						{/* In Active Prop Declaimer */}
						{!listing.active && (
							<>
								<div className="container is-disabled-property padding">
									<Card
										bodyStyle={{
											background: theme.colors.warningColor,
										}}>
										<Typography.Title
											style={{
												margin: 0,
												textAlign: "center",
											}}
											level={5}>
											{
												"Estás viendo esta página porque la propiedad que estabas buscando no está disponible."
											}
										</Typography.Title>
									</Card>
								</div>
								<PropertyInactive listing={listing} mode={mode} />
								{((listing.isProject && listing.commercial_units.length > 0) ||
									!listing.isProject && listing.active) && (
										<Col span={24} className="padding">
											<div className="container similar-container">
												<LoadOnScreen listen={!loading}>
													<PropertySimilarsCards
														id={listing.id}
														mode={mode}
														title={
															mode === "project"
																? "Proyectos de la constructora"
																: null
														}
														ownerId={
															mode === "project" ? listing.owner.id : null
														}
													/>
												</LoadOnScreen>
											</div>
										</Col>
									)}
							</>
						)}

						{/* Content */}
						<Col span={24} className="pd-main-content">
							<div className="header-info">
								{showLogo(listing) && (
									<div className="left">
										<figure className="figure-image">
											<img src={listing.logo} alt="Logo" className="image" />
										</figure>
									</div>
								)}

								<div className="right">
									<Row className="location-header">
										<Col>
											<p className="body body-bold medium">
												Ubicación Principal
											</p>
											<p className="body body-regular medium">
												{getLocationLabel(country_name, listing.locations)}
											</p>
										</Col>
										{country_code === "CO" ? (
											<Col>
												<p className="body body-bold medium">
													Ubicaciones asociadas
												</p>
												<p className="body body-regular medium">
													{neighbourhoodNames?.length <= 2 ? (
														<>
															{neighbourhoodNames?.join(", ")}
															{listing?.locations?.locality[0] &&
																", " +
																listing?.locations?.locality[0]
																	?.name}
															{listing?.locations?.commune[0] &&
																", " +
																listing?.locations?.commune[0]
																	?.name}
															{listing?.locations?.city[0] &&
																", " +
																listing?.locations?.city[0]
																	?.name}
														</>
													) : (
														<>
															{displayedNeighbourhoods?.join(", ")}
															{neighbourhoodNames?.length > 3 &&
																!showAllNeighbourhoods &&
																", ..."}
															{showAllNeighbourhoods &&
																neighbourhoodNames?.length > 3 && (
																	<>
																		{listing?.locations?.zone[0]
																			?.name &&
																			", " +
																			listing?.locations
																				?.zone[0]
																				?.name +
																			", "}
																		{listing?.locations
																			?.locality[0]?.name &&
																			listing?.locations
																				?.locality[0]
																				?.name + ", "}
																		{listing?.locations
																			?.commune[0]?.name &&
																			listing?.locations
																				?.commune[0]?.name}
																		{", " +
																			listing?.locations
																				?.city[0]?.name}
																	</>
																)}
														</>
													)}
												</p>
												{neighbourhoodNames?.length > 3 && (
													<>
														{showAllNeighbourhoods ? (
															<a
																className="toggle-visibility"
																onClick={() =>
																	setShowAllNeighbourhoods(false)
																}>
																<OpenEyeIcon width={16} />
																<span>Ver menos</span>
															</a>
														) : (
															<a
																className="toggle-visibility"
																onClick={() =>
																	setShowAllNeighbourhoods(true)
																}>
																<CloseEyeIcon width={16} />
																<span>Ver más</span>
															</a>
														)}
													</>
												)}
											</Col>
										) : null}
									</Row>
								</div>
							</div>
							{/* {country_code === "CO" &&
								listing.isProject &&
								listing.fair &&
								listing.fair?.active && (
									<Row>
										<Col span={24} lg={17}>
											<Col span={24}>
												<div className="finca-clic-info">
													<FincaClicLogo />
													<div className="info-text">
														<FireIcon /> {listing.fair.detail_text}
													</div>
												</div>
											</Col>
										</Col>
									</Row>
								)} */}

							<Row>
								<Col
									span={24}
									lg={17}
									className="pd-main-content-left padding-reverse-extra">
									<Col span={24} className="pd-main-top">
										<OnScreen
											onEnterView={() => {
												setShowAffix(false);
											}}
											onLeaveView={() => {
												setShowAffix(true);
											}}>
											{/* Property Cover */}
											<Col
												span={24}
												className="pd-property-cover-col padding-reverse-extra">
												<div className="container pd-container">
													{country_code === "CO" &&
													listing.isProject &&
													listing.fair &&
													listing.fair?.active && (
														<div className="finca-clic-info">
															<FincaClicLogo />
															<div className="info-text">
																<FireIcon /> {listing?.fair?.detail_text}
															</div>
														</div>
													)}			
													<PropertyCover
														isDisabledProperty={!listing.active}
														tour3d={listing.tour3d}
														images={listing.images}
														img={listing.img}
														isProject={listing.isProject}
														mode={mode}
														id={listing.id}
														onTabClick={tab => {
															setModalTabOpen(tab);
															setModalOpen(true);
														}}
														loading={loading}
														files={listing.files}
														latitude={listing.latitude}
													/>
												</div>
											</Col>

											<Col
												span={24}
												className="pd-main-content-info padding-other">
												<div className="container">
													<Row
														gutter={[
															{
																sm: theme.spacing.smSpacing,
																xs: theme.spacing.smSpacing,
																lg: theme.spacing.mdSpacing,
															},
															theme.spacing.lgSpacing,
														]}>
														<Col span={24} sm={14} lg={14}>
															{/* Title */}
															<Title
																title={listing.title}
																limitLength={2}
																hideInformation={false}
																loading={loading}
															/>

															{/* Typology Tag Desktop */}
															<TypologyTag
																propertyType={
																	listing.isProject &&
																		minAndMaxUnits.minUnit
																			?.property_type
																		? minAndMaxUnits.minUnit
																			?.property_type.id
																		: propertyTypeId
																}
																operationType={operationTypeId}
																bedrooms={
																	listing.isProject
																		? projectBedrooms
																		: listing.bedrooms
																}
																rooms={
																	listing.isProject
																		? projectRooms
																		: listing.rooms
																}
																bathrooms={
																	listing.isProject
																		? projectBathrooms
																		: listing.bathrooms
																}
																m2={
																	listing.minM2 > 0
																		? listing.minM2
																		: listing.m2 > 0
																			? listing.m2
																			: listing.project?.minM2 > 0
																				? listing.project.minM2
																				: null
																}
																guests={listing.guests}
																loading={loading}
																className="property-typology-tag-desktop"
																showIcons
																isProject={!!listing.isProject}
															/>
														</Col>

														{/* Price Tag */}
														{!isTemporal(operationTypeId) &&
															listing.price ? (
															<Col span={24} sm={10} lg={10}>
																<PriceTag
																	showOperationType={true}
																	showExpenses={
																		listing?.commonExpenses
																			?.amount > 0
																	}
																	include_administration={
																		listing.include_administration
																	}
																	shortExpensesText={false}
																	mode={mode}
																	price={
																		listing.isProject
																			? minAndMaxUnits.minUnit
																				?.price
																			: listing.price
																	}
																	maxPrice={
																		listing.isProject
																			? minAndMaxUnits.maxUnit
																				?.price
																			: null
																	}
																	priceVariation={
																		listing.price_variation
																	}
																	commonExpenses={
																		listing.commonExpenses
																	}
																	temporalCurrency={
																		listing.temporal_currency
																	}
																	temporalPrice={
																		listing.temporal_price
																	}
																	operationType={
																		listing.operation_type
																	}
																	isProject={listing.isProject}
																	loading={loading}
																/>
															</Col>
														) : null}

														{/* Property Local Information */}
														<Col span={24}>
															<PropertyLocalInformationMap
																isProject={listing.isProject}
																latitude={listing.latitude}
																longitude={listing.longitude}
																pointType={listing?.pointType}
																onStreetViewClick={() => {
																	setModalTabOpen("streetView");
																	setModalOpen(true);
																}}
																onMapClick={() => {
																	if (
																		!listing.latitude ||
																		!listing.longitude
																	)
																		return;
																	setModalTabOpen("map");
																	setModalOpen(true);
																}}
																id={listing.id}
																propId={id} // Envio el Id de la prop que recibe el componente, cuando es proyecto se pierde el Id al hacer spread en los hook.
																mode={mode}
																seaDistance={
																	listing.seaDistanceName
																}
															/>
														</Col>
													</Row>
												</div>
											</Col>
										</OnScreen>
									</Col>

									{mode === "property" && (
										<Col span={24} className="padding">
											<div className="container">
												<h4 className="subhead subhead-semibold high">
													Detalles de la Propiedad
												</h4>

												<TechnicalSheet
													isDisabledProperty={!listing.active}
													mode={mode}
													id={listing.id}
													technicalSheets={listing?.technicalSheet}
													loading={loading}
													isProject={listing.isProject}
													officeFriendly={listing.office ?? false}
													penthouse={listing.penthouse ?? false}
													operationType={listing?.operation_type?.id}
													propertyType={propertyTypeId}
													isMono={
														listing?.rooms >= 1 &&
														listing?.bedrooms === 0 &&
														country_code !== "CO"
													}
												/>
											</div>
										</Col>
									)}

									{/* Infomación del proyecto */}
									{mode === "project" && (
										<Col span={24} className="padding">
											<div className="container">
												<h4 className="subhead subhead-semibold high">
													{"Información del proyecto"}
												</h4>

												<ProjectInfo
													projectId={id}
													loading={loading}
													percentageFinished={listing.percentage_finished}
													percentageSold={listing.percentage_sold}
													ocupation={listing.ocupation}
													builder={listing.builder}
													finalization={listing.finalization}
													technicalSheet={listing.technicalSheet ?? null}
													isActive={listing?.active}
												/>

												{country_code === "CO" ? (
													<span className="info body body-2 low">
														ⓘ La clasificación del estrato es
														potestativo del municipio, el anunciante no
														puede comprometerse con una clasificación
														determinada del estrato el cual queda
														definido en el momento de recibo de la obra.
													</span>
												) : null}
											</div>
										</Col>
									)}

									{/* Ambientes && Amenities */}
									<Col span={24} className="padding">
										<div className="container">
											<Show when={listing?.facilities}>
												<Facilities
													mode={mode}
													facilities={listing.facilities}
													loading={loading}
												/>
											</Show>
										</div>
									</Col>

									{/* Owner Info */}
									{screen.xs && listing.owner ? (
										<div className="padding">
											<div className="container">
												<h4 className="subhead subhead-semibold high">
													Publicado por:
												</h4>
												<OwnerInfo owner={listing.owner} />
											</div>
										</div>
									) : null}

									{/* Description */}
									{(listing.description || mode === "project") && (
										<Col span={24} className="padding description-container">
											<div className="container">
												<Description
													description={listing.description}
													loading={loading}
													hideInformation={false}
													showTitle={true}
													cleanHtmlWithLineBreaks
												/>
											</div>
										</Col>
									)}
									{country_code === "CO" && listing.id && (
										<span
											style={{
												color: "#456787",
												fontWeight: 400,
												paddingLeft: "33px",
												fontSize: "13px",
											}}>
											Código Fincaraíz: {listing.id}
										</span>
									)}

									{country_code !== "CO" && (
										<div className="container padding">
											<Guarantee
												guarantee={listing.guarantee}
												opTypeID={listing.operation_type?.id}
											/>
										</div>
									)}

									{/* Financiación*/}
									<Show when={listing.isProject !== true}>
										<Col span={24} className="padding" ref={financingRef}>
											<div className="container">
												<Financing
													id={listing.id}
													reference={listing.code}
													isDisabledProperty={!listing.active}
													operationType={operationTypeId}
													propertyType={propertyTypeId}
													propertyPrice={listing.price}
													showFinancingCard={false}
												/>
											</div>
										</Col>
									</Show>

									{/* Unidades */}
									{!!(mode === "project" && listing.commercial_units?.length) && (
										<Col span={24} className="padding">
											<div className="container">
												<Typography.Title level={4}>
													{firstLetterToUppercase(translations.unidades)}
												</Typography.Title>
												<Units
													comertialUnits={listing.commercial_units}
													loading={loading}
												/>

												<span className="info body body-2 low">
													ⓘ La Constructora puede variar los precios del
													proyecto, según sus políticas de
													comercialización.
												</span>
											</div>
										</Col>
									)}

									{/* Avances de obra */}
									{mode === "project" && (
										<Col span={24} className="padding">
											<div className="container">
												<WorkProgress
													images={listing.images}
													loading={loading}
												/>
											</div>
										</Col>
									)}

									{/* Big Data Single Prop */}
									{!ocultarBigDataFicha_aPedidoHardcodeado(listing.id) &&
										mode !== "project" &&
										!isTemporal(operationTypeId) && (
											<Col span={24} className="padding">
												<div className="container">
													<BigDataSingleProp id={listing.id} />
												</div>
											</Col>
										)}

									{/* OfficeHours */}
									{mode === "project" &&
										country_code !== "BR" &&
										country_code !== "CO" && (
											<Col span={24} className="padding-extra">
												<div className="container">
													<Typography.Title level={4}>
														{"Horario de oficina"}
													</Typography.Title>
													<OfficeHours owner={listing.owner} />
												</div>
											</Col>
										)}
								</Col>

								<Col
									span={0}
									lg={7}
									className="pd-main-content-right padding-reverse-extra">
									{" "}
									{/* Financiación Card*/}
									<Show when={listing.isProject !== true}>
										<Col span={24}>
											<div>
												<Financing
													id={listing.id}
													reference={listing.code}
													isDisabledProperty={!listing.active}
													operationType={operationTypeId}
													propertyType={propertyTypeId}
													propertyPrice={listing.price}
													showFinancingCard={true}
													financingRef={financingRef}
												/>
											</div>
										</Col>
									</Show>
									<Col
										span={24}
										id={"myForm"}
										className="col-information-request-small-left information-box">
										{/* Information Request*/}
										<InformationRequest
											id={listing.id}
											disabled={!listing.active}
											showCTA
											owner={listing.owner}
											queryRouter={queryRouter}
											isProject={listing.isProject}
											source="propertyDetailMain"
											ctaToShow={{
												contact: true,
												phone: true,
												whatsapp: true,
											}}
										/>
									</Col>
								</Col>
							</Row>
						</Col>

						{/* Calendar */}
						<Show when={isTemporal(operationTypeId) && country_code !== "CO"}>
							<div className="container padding">
								<Typography.Title level={4}>
									{"Calendario de disponibilidad"}
								</Typography.Title>
								<AvailabilityCalendar occupancies={listing.occupancies} />
							</div>
						</Show>

						{/* Temporary Rental */}
						<Show when={isTemporal(operationTypeId) && country_code !== "CO"}>
							<div className="container padding">
								<Typography.Title level={4}>{"Alquiler Temporal"}</Typography.Title>
								<TemporaryRental id={listing.id} seasons={listing.seasons} isActive={!!listing?.active} />
							</div>
						</Show>

						{((listing.isProject && listing.commercial_units.length > 0) ||
							!listing.isProject) && !!listing.active && (
								<Col id="mySimilar" span={24} className="property-similar-col padding">
									<div className="container">
										<LoadOnScreen listen={!loading}>
											<PropertySimilars
												id={listing.id}
												mode={mode}
												isTemporal={isTemporal(operationTypeId)}
												show={listing.price?.amount > 0}
												ownerId={mode === "project" ? listing?.owner?.id : null}
											/>
										</LoadOnScreen>
									</div>
								</Col>
							)}

						{/* Sub Sidiaries && Information Request */}
						{screen.lg ? (
							<div className="container pd-ir-container-big padding">
								<OnScreen
									onEnterView={() => setShowAffixBottom(false)}
									onLeaveView={() => setShowAffixBottom(true)}>
									<InformationRequest
										id={listing.id}
										owner={listing.owner}
										disabled={!listing.active}
										inmoPropsLink={
											listing.owner ? listing.owner.inmoPropsLink : undefined
										}
										isProject={listing.isProject}
										ctaToShow={{
											contact: true,
											phone: true,
											whatsapp: true,
										}}>
										<Subsidiaries
											id={listing.id}
											listing={listing}
											mode={mode}
											owner={listing.owner}
											loading={loading}
											seller={listing.seller}
											disabled={!listing.active}
										/>
									</InformationRequest>
								</OnScreen>
							</div>
						) : null}

						{/* Seo Text */}
						<div className="container padding">
							<SeoText />
						</div>

						{/* Seo Text BreadCrumbs */}
						<div className="container padding">
							<Text>
								<BreadCrumbs />
							</Text>
						</div>

						{/* Footer */}
						<div className="container">
							<Footer />
						</div>
					</div>

					{/* Footer Image */}
					<PicHomeFooter />

					{/* show Affix Bottom && Property Affix Bottom */}
					{listing.active && showAffixBottom && shouldShowMobileAffix && (
						<PropertyAffixBottom
							id={
								listing.isProject && listing.project.id
									? listing.project.id
									: listing.id
							}
							mode={mode}
							owner={listing.owner}
							isProject={listing.isProject}
						/>
					)}

					{/*Modal de consulta*/}
					{isVisible || modalData ? (
						<ModalConsulta
							modal={isVisible}
							closeModal={closeContactModal}
							onSuccess={closeContactModal}
							defaultMessage={modalData.defaultMessage}
							owner={modalData.owner}
							id={modalData.id}
							isProject={modalData.isProject}
							projectId={modalData.projectId}
							source={modalData.source}
							propertyLink={modalData.propertyLink}
							isAuthModalShowing={isAuthModalShowing}
							isExpress={modalData.isExpress ?? false}
							expressCallback={modalData.expressCallback ?? undefined}
						/>
					) : null}
				</div>
				<style jsx global>{`
					.property-detail .pd-main-content-right .sticky {
						top: ${top}px;
						position: -webkit-sticky;
						position: sticky;
						transition: all 0.5s ease 0s;
					}
				`}</style>
			</div>
		</>
	);
}
